import instance from '@/api/instance';

////////// CP APP
export let CpSiteAppCreate = function (data) {
    return instance.post('/cpsite/app/create', data)
}

export let CpSiteAppUpdate = function (data) {
    return instance.post('/cpsite/app/update', data)
}

export let CpSitAppRead = function (data) {
    return instance.post('/cpsite/app/read', data)
}

////////// CP Templates
export let CpSiteTplCreate = function (data) {
    return instance.post('/cpsite/tpl/create', data)
}

export let CpSiteTplUpdate = function (data) {
    return instance.post('/cpsite/tpl/update', data)
}

export let CpSiteTplRead = function (data) {
    return instance.post('/cpsite/tpl/read', data)
}

export let CpSiteTplDrop = function (data) {
    return instance.post('/cpsite/tpl/drop', data)
}

////////// CP PACK
export let CpSitePackRead = function (data) {
    return instance.post('/cpsite/pack/read', data)
}

////////// CP Balance
export let CpSiteBalanceRead = function (data) {
    return instance.post('/cpsite/balance/read', data)
}

////////// CP TRX
export let CpSiteTrxRead = function (data) {
    return instance.post('/cpsite/trx/read', data);
}

////////// CP Summary
export let CpSiteDashSummaryRead = function (data) {
    return instance.post('/cpsite/dash/summary', data)
}

////////// CP Address
export let CpSiteAddressRead = function (data) {
    return instance.post('/cpsite/address/read', data)
}

export let CpSiteAddressUpdate = function (data) {
    return instance.post('/cpsite/address/update', data)
}

export let CpSiteAddressDrop = function (data) {
    return instance.post('/cpsite/address/drop', data)
}

export let CpSiteAddressCreate = function (data) {
    return instance.post('/cpsite/address/create', data)
}

////////// CP Address Items
export let CpSiteAddressItemsCreate = function (data) {
    return instance.post('/cpsite/address/items/create', data)
}

export let CpSiteAddressItemsDrop = function (data) {
    return instance.post('/cpsite/address/items/drop', data)
}

export let CpSiteAddressItemsRead = function (data) {
    return instance.post('/cpsite/address/items/read', data)
}

export let CpSiteAddressItemsImport = function (data) {
    return instance.post('/cpsite/address/items/import', data)
}

////////// CP Campaign
export let CpSiteCampaignCreate = function (data) {
    return instance.post('/cpsite/campaign/create', data)
}

export let CpSiteCampaignUploadSign = function (data) {
    return instance.post('/cpsite/campaign/upload/sign', data)
}

export let CpSiteCampaignReportRead = function (data) {
    return instance.post('/cpsite/campaign/report/read', data)
}